require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./redux-wrap-up.json") })
        }
      }, "path---redux-wrap-up");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---redux-wrap-up!./.cache/json/redux-wrap-up.json
// module id = 404
// module chunks = 231608221292675